import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ActivityService {

    static getActivity(item = {}) {
        let api = `${API_BASE_URL}${API_PATHS.getactivity}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.search) params.append("search", item.search);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }

    static addActivity(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addactivity}`;
        return axiosInstance
            .post(api, data)

    }

    static editActivity(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editactivity}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteActivity(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteactivity}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default ActivityService;
